var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _connector;
import { subscription } from '@aragon/connect-core';
import { formatBn } from '../helpers';
export default class StakingMovement {
    constructor(data, connector) {
        _connector.set(this, void 0);
        __classPrivateFieldSet(this, _connector, connector);
        this.id = data.id;
        this.stakingId = data.stakingId;
        this.agreementId = data.agreementId;
        this.tokenId = data.tokenId;
        this.tokenSymbol = data.tokenSymbol;
        this.tokenDecimals = data.tokenDecimals;
        this.amount = data.amount;
        this.actionId = data.actionId;
        this.disputableAddress = data.disputableAddress;
        this.disputableActionId = data.disputableActionId;
        this.actionState = data.actionState;
        this.collateralState = data.collateralState;
        this.createdAt = data.createdAt;
    }
    async disconnect() {
        await __classPrivateFieldGet(this, _connector).disconnect();
    }
    get formattedAmount() {
        return formatBn(this.amount, this.tokenDecimals);
    }
    async token() {
        return __classPrivateFieldGet(this, _connector).ERC20(this.tokenId);
    }
    onToken(callback) {
        return subscription(callback, (callback) => __classPrivateFieldGet(this, _connector).onERC20(this.tokenId, callback));
    }
    async staking() {
        return __classPrivateFieldGet(this, _connector).staking(this.stakingId);
    }
    onStaking(callback) {
        return subscription(callback, (callback) => __classPrivateFieldGet(this, _connector).onStaking(this.stakingId, callback));
    }
    async action() {
        const action = await this.tryAction();
        if (!action) {
            throw Error(`Could not find given action number ${this.actionId}`);
        }
        return action;
    }
    async tryAction() {
        return __classPrivateFieldGet(this, _connector).action(this.actionId);
    }
    onAction(callback) {
        return subscription(callback, (callback) => __classPrivateFieldGet(this, _connector).onAction(this.actionId || '', callback));
    }
}
_connector = new WeakMap();
//# sourceMappingURL=StakingMovement.js.map